import { AllVoidTypeStateType } from './Types';

export const allVoidTypeInitialState: AllVoidTypeStateType = {
	loading: false,
	error: null,
	data: null,
};
